export default "__VITE_ASSET__DkXcBP_9__"